/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 前日在庫引当フラグ
 * @export
 * @interface ShipPreviousStockFlg
 */
export interface ShipPreviousStockFlg {
}

/**
 * Check if a given object implements the ShipPreviousStockFlg interface.
 */
export function instanceOfShipPreviousStockFlg(value: object): value is ShipPreviousStockFlg {
    return true;
}

export function ShipPreviousStockFlgFromJSON(json: any): ShipPreviousStockFlg {
    return ShipPreviousStockFlgFromJSONTyped(json, false);
}

export function ShipPreviousStockFlgFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipPreviousStockFlg {
    return json;
}

export function ShipPreviousStockFlgToJSON(json: any): ShipPreviousStockFlg {
    return ShipPreviousStockFlgToJSONTyped(json, false);
}

export function ShipPreviousStockFlgToJSONTyped(value?: ShipPreviousStockFlg | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

